import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {LogoutOutlined} from '@ant-design/icons';
import {Avatar, Dropdown} from 'antd';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {Store} from '../../model/store/Store';
import {fullUrl} from '../../shared/helpers/fullUrl';

import {WidgetStory} from './Widgets/Story/WidgetStory';
import {Widget} from './Widgets/Widget';
import {WidgetApplication} from './Widgets/WidgetApplication';

import cls from './Index.module.scss'

export const Index = observer(() => {

    const {auth} = useInstance(Store)
    const {t} = useTranslation();

    const userMenu = {
        items: [
            {
                key: 'logout',
                label: t('Logout'),
                icon: <LogoutOutlined />,
                onClick: () => auth.clearState(),
            },
        ],
    };

    const avatar =
        <>
            <Dropdown menu={userMenu} trigger={['click']}>
                <Avatar size={32} src={auth.data?.avatar ? fullUrl(auth.data?.avatar) : undefined}>
                    {auth.data?.FIO!.charAt(0)}
                </Avatar>
            </Dropdown> {auth.data?.FIO}
        </>

    return (
        <Layout header={<Header left={avatar} title={'AI Vita'}/>}>
            <div className={cls.cards}>

                {_.map(auth.widgets, widget => {
                        if (widget?.identifier === 'analyzes' || widget?.identifier === 'research' || widget?.identifier === 'consultations') {
                            return <WidgetStory key={widget.identifier} identifier={widget.identifier} content={widget.content!}/>
                        } else if (widget?.identifier === 'bigAnket') {
                            return (<WidgetApplication key={widget.identifier}/>)
                        } else {
                            return (<Widget key={widget?.identifier!} identifier={widget?.identifier!}/>)
                        }
                    }
                )}
            </div>
        </Layout>
    )
})